import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { useLandingContent } from "web/react/hooks/use-landing-content/use-landing-content";
import withReduxProvider from "web/react/redux-provider";
import FeedsSeoContactDetails from "./feeds-seo-contact-details/feeds-seo-contact-details";
import styles from "./feeds-seo-content.module.css";
import FeedsSeoFaq from "./feeds-seo-faq/feeds-seo-faq";

function mapStateToProps(state) {
    const { visible } = state.feedSeoContentReducer;
    return {
        showContent: visible,
    };
}

function FeedsSeoProfileContents({ showContent, expandedContents }) {
    const { about_section: about, contact_details: contactDetails, faq } = expandedContents;
    const showLandingContent = useLandingContent();

    // Before rending SEO content module, make sure that one section has a content at least.
    // Otherwise, in case of no SEO content and if we skip this check,
    // `styles.feedsSeoContent` adds an extra padding and border.
    const hasAbout = !!(about.title && about.body);
    const hasContacts = !!(
        contactDetails.email_address ||
        contactDetails.phone_number ||
        contactDetails.address
    );
    const hasFaq = !!(faq.title || (faq.items && faq.items.length > 0));
    const hasSeoContent = hasAbout || hasContacts || hasFaq;

    if (!showContent || !showLandingContent || !hasSeoContent) {
        return null;
    }

    let aboutSection = null;

    if (about.title && about.body) {
        aboutSection = (
            <>
                <h2 className={styles.introTitle}>{about.title}</h2>
                <div
                    className={styles.introBody}
                    dangerouslySetInnerHTML={{ __html: about.body }}
                />
            </>
        );
    }

    return (
        <div className={styles.feedsSeoContent}>
            {aboutSection}
            <FeedsSeoContactDetails contactDetails={contactDetails} />
            <FeedsSeoFaq faq={faq} />
        </div>
    );
}

FeedsSeoProfileContents.propTypes = {
    showContent: PropTypes.bool,
    expandedContents: PropTypes.shape({
        about_section: PropTypes.object,
        contact_details: PropTypes.object,
        faq: PropTypes.object,
    }),
};

export default withReduxProvider(connect(mapStateToProps)(FeedsSeoProfileContents));
